import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Chip,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Loading from '../../../../components/loading';
import ErrorMessage from '../../../../components/errorMessage';
import { usePatientAppointments } from '../hooks/usePatientAppointments';
import {
  formatDateAndTime,
  formatDuration,
  formatText,
  getStatusColor,
  getStatusLabel,
  sortByDateDesc,
} from '../appointmentFields';

export default function AppointmentListMobile() {
  const { patientId } = useParams();
  const navigate = useNavigate();

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { appointments, isLoading, error: listError } = usePatientAppointments(patientId);

  useEffect(() => {
    if (listError) {
      setShowErrorMessage(true);
      setErrorMessage(listError);
    }
  }, [listError]);

  const sortedAppointments = useMemo(() => sortByDateDesc(appointments), [appointments]);

  const openAppointment = (appointmentId) => {
    navigate(`/appointment/${appointmentId}`);
  };

  return (
    <>
      <Loading isToHidden={isLoading === false} />
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
          Consultas
        </Typography>

        {sortedAppointments.length === 0 ? (
          <Typography align="center" sx={{ py: 4 }}>
            Nenhuma consulta encontrada para este paciente.
          </Typography>
        ) : (
          <List disablePadding>
            {sortedAppointments.map((appointment) => (
              <ListItem
                key={appointment.id}
                divider
                secondaryAction={
                  <IconButton color="primary" onClick={() => openAppointment(appointment.id)}>
                    <OpenInNewIcon />
                  </IconButton>
                }
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Typography sx={{ fontWeight: 'bold' }}>
                      {formatDateAndTime(appointment)}
                    </Typography>
                  }
                  secondary={
                    <Box sx={{ mt: 0.5 }}>
                      <Typography variant="body2" color="text.secondary">
                        Profissional: {formatText(appointment.dentistName)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Tipo: {formatText(appointment.appointmentType)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Duração: {formatDuration(appointment)}
                      </Typography>
                      {appointment.observation && (
                        <Typography variant="body2" color="text.secondary">
                          Observação: {appointment.observation}
                        </Typography>
                      )}
                      <Chip
                        size="small"
                        sx={{ mt: 1 }}
                        label={getStatusLabel(appointment)}
                        color={getStatusColor(appointment)}
                      />
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </>
  );
}
